import React from 'react';

import { useTestLogin } from './hooks';
import { LoadingView } from '@components';

export const TestLoginRoute = () => {
    const {
        onSubmit,
        onBlur,
        isLoading,
        state
    } = useTestLogin();

    if (isLoading) {
        return <LoadingView />;
    }

    return (
        <form onSubmit={onSubmit}>
            <input
                autoComplete={'on'}
                data-testid={'username'}
                id={'username'}
                onChange={onBlur}
                placeholder={'Username'}
                defaultValue={state?.username || ''}
            />

            <input
                autoComplete={'on'}
                data-testid={'password'}
                id={'password'}
                onChange={onBlur}
                placeholder={'Password'}
                type={'password'}
                defaultValue={state?.password || ''}
            />

            <select id={'env'} data-testid={'env'} defaultValue={state?.env || 'qa'} onBlur={onBlur}>
                <option value={'demo'}>Demo</option>
                <option value={'qa'}>QA</option>
                <option value={'live'}>Live</option>
            </select>

            <button data-testid={'submit-button'} type={'submit'}>
                Login
            </button>
        </form>
    );
};
